(function () {
  const toggleButtons = document.querySelectorAll(
    "[data-collection-sort-toggle]",
  );

  toggleButtons.forEach((button) => {
    const dropdownId = button.getAttribute("aria-controls");
    const dropdown = document.getElementById(dropdownId);

    if (!dropdown) return;

    button.addEventListener("click", () => {
      const isExpanded = button.getAttribute("aria-expanded") === "true";
      button.setAttribute("aria-expanded", String(!isExpanded));
      dropdown.classList.toggle("hidden");
    });
  });

  const sortSelects = document.querySelectorAll(
    "[data-collection-sort-select]",
  );

  sortSelects.forEach((select) => {
    select.addEventListener("change", () => {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", select.value);
      window.location.href = url.toString();
    });
  });
})();
